import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

import { tap } from 'rxjs/operators';
import { Type } from '../../../../../../api/src/dataimport/dataimport.entity';
import {ImportEvent} from "../../../shared/components/data-import-dialog/data-import-dialog-data.model";

export type FileDataImportUploadObject = {
	id?: string;
	title?: string;
	mimeType?: string;
	type?: Type;
	uploaded?: boolean;
	uploading?: boolean;
	userId?: string;
	businessId?: string;
	file: File;
};

@Injectable({ providedIn: 'root' })
export class DataImportService {
	constructor(private readonly http: HttpClient) {}

	public upload(fileReq: FileDataImportUploadObject, siteId: string, event: ImportEvent, businessId?: string, provider: string = 'amazon') {
		const formData: FormData = new FormData();

		if (!fileReq.file || !(fileReq.file instanceof File)) {
			throw new Error('Invalid file provided for upload');
		}

		formData.append('file', fileReq.file);
		// formData.append('userId', userId);
		// formData.append('name', fileReq.file.name);

		
		let importUrl: string;
		switch (event) {
			case ImportEvent.DataImport:
				formData.append('title', fileReq.title ?? fileReq.file.name);
				formData.append('provider', provider || 'amazon');
				formData.append('type', fileReq.type as string);

				importUrl = `${environment.apiUrl}/dataimport/site/${siteId}`;
				break;
			case ImportEvent.DataSourceImport:
				formData.append('siteId', siteId);

				importUrl = `${environment.apiUrl}/data-source/bulk-import`;
				break;
			case ImportEvent.UserInviteImport:
				formData.append('businessId', businessId);
				formData.append('siteId', siteId);

				importUrl = `${environment.apiUrl}/dataimport/${businessId}/invite-users`;
				break;
			default:
				formData.append('siteId', siteId);

				importUrl = `${environment.apiUrl}/dataimport/users`;
				break;
		}

		return this.http
			.request(
				new HttpRequest('POST', importUrl, formData, {
					reportProgress: true,
					responseType: 'json'
				})
			)
			.pipe(
				tap((res: any) => {
					return { ...fileReq, uploaded: true, uploading: false, body: res.body };
					// this.updateImportList(siteId, projectId, businessId);
				})
			);
	}
}
